module.exports = __webpack_public_path__ + "img/formula.101324be.jpg";